// Theme JavaScript

document.addEventListener('DOMContentLoaded', () => {
    initCartDrawer();
    initSearchDrawer();
});

/* ============================================================================
   Cart Drawer Logic
   ========================================================================= */
function initCartDrawer() {
    const cartToggle = document.getElementById('cart-toggle');
    const cartDrawerContainer = document.getElementById('cart-drawer-container');

    // Open Cart
    if (cartToggle) {
        cartToggle.addEventListener('click', (e) => {
            e.preventDefault();
            openCart();
        });
    }

    // Add to Cart Forms
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            console.log("Add to cart intercepted!");
            const formData = new FormData(form);
            const id = formData.get('id');
            const quantity = formData.get('quantity') || 1;

            try {
                // Add item
                const res = await fetch(window.routes.cart_add_url + '.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        items: [{
                            id: parseInt(id, 10),
                            quantity: parseInt(quantity, 10)
                        }]
                    })
                });
                
                const data = await res.json();
                console.log("Add to cart response:", data);

                if (!res.ok) {
                    alert("Erreur: " + (data.description || data.message || "Impossible d'ajouter au panier."));
                    return;
                }

                // Open cart and update
                await updateCartDrawer();
                openCart();
            } catch (err) {
                console.error("Fetch error:", err);
            }
        });
    });

    bindCartEvents(); // Bind events on initial load
}

async function updateCartDrawer() {
    // Check and enforce maximum limit of 4 per variant
    try {
        const cartRes = await fetch(window.routes.cart_url + '.js');
        const cart = await cartRes.json();
        let needsClamp = false;
        let updates = {};
        
        cart.items.forEach(item => {
            if (item.quantity > 4) {
                updates[item.variant_id] = 4;
                needsClamp = true;
            }
        });

        if (needsClamp) {
            await fetch(window.routes.cart_update_url + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
            });
        }
    } catch (e) {
        console.error("Error clamping cart:", e);
    }

    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    const newDrawer = html.getElementById('shopify-section-cart-drawer');
    const container = document.getElementById('cart-drawer-container');

    if (newDrawer && container) {
        container.innerHTML = newDrawer.innerHTML;
        bindCartEvents(); // Re-bind events for remove buttons, etc.

        // Update Cart Count in Header
        const count = html.querySelector('[data-cart-count]')?.dataset.cartCount;
        const headerCount = document.getElementById('cart-count');
        if (headerCount && count) headerCount.textContent = count;
    }
}

function openCart() {
    document.getElementById('cart-drawer-overlay')?.classList.remove('hidden');
    document.getElementById('cart-drawer')?.classList.remove('translate-x-full');
    document.body.classList.add('overflow-hidden');

    // Initial fetch if empty
    if (!document.getElementById('cart-drawer')) {
        updateCartDrawer();
    }
}

function closeCart() {
    document.getElementById('cart-drawer-overlay')?.classList.add('hidden');
    document.getElementById('cart-drawer')?.classList.add('translate-x-full');
    document.body.classList.remove('overflow-hidden');
}

function bindCartEvents() {
    // Close Button/Overlay
    document.querySelectorAll('.cart-close').forEach(btn => {
        btn.addEventListener('click', closeCart);
    });

    // Remove Item
    document.querySelectorAll('.cart-remove').forEach(btn => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const line = btn.dataset.line;

            await fetch(window.routes.cart_change_url + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: line, quantity: 0 })
            });

            updateCartDrawer();
        });
    });
}

async function updateCartItem(id, quantity) {
    await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity })
    });
    updateCartDrawer();
}

/* ============================================================================
   Search Drawer Logic
   ========================================================================= */
function initSearchDrawer() {
    const searchToggle = document.getElementById('search-toggle');
    const searchInput = document.getElementById('search-input');
    
    if (searchToggle) {
        searchToggle.addEventListener('click', (e) => {
            e.preventDefault();
            openSearch();
        });
    }

    if (searchInput) {
        searchInput.addEventListener('input', debounce(async (e) => {
            const query = e.target.value.trim();
            if (query.length < 2) {
                document.getElementById('search-results').innerHTML = '<div class="text-xs opacity-50 uppercase text-center mt-10">Type to search...</div>';
                return;
            }

            // Fetch predictive search results
            const res = await fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&section_id=predictive-search`);
            const text = await res.text();
            
            const html = new DOMParser().parseFromString(text, 'text/html');
            const resultsDiv = html.getElementById('shopify-section-predictive-search');
            
            if (resultsDiv) {
                document.getElementById('search-results').innerHTML = resultsDiv.innerHTML;
            }
        }, 300));
    }

    bindSearchEvents();
}

function openSearch() {
    document.getElementById('search-drawer-overlay')?.classList.remove('hidden');
    document.getElementById('search-drawer')?.classList.remove('translate-x-full');
    document.body.classList.add('overflow-hidden');
    document.getElementById('search-input')?.focus();
}

function closeSearch() {
    document.getElementById('search-drawer-overlay')?.classList.add('hidden');
    document.getElementById('search-drawer')?.classList.add('translate-x-full');
    document.body.classList.remove('overflow-hidden');
}

function bindSearchEvents() {
    document.querySelectorAll('.search-close').forEach(btn => {
        btn.addEventListener('click', closeSearch);
    });
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

